import React from "react";
import { sectionTwoProblems } from "../../data";
import {
  SectionTwo,
  SectionTwoInner,
  ProblemTitle,
  ProblemGrid,
  ProblemCard,
  ProblemIcon,
  ProblemLabel,
  PracticeTitle,
  PracticeText,
  SectionTwoCta
} from "./styles";

export default function SectionTwoComponent({ onOpenPlans }) {
  return (
    <SectionTwo>
          <SectionTwoInner>
            <ProblemTitle>
              <strong>SEU PACIENTE NÃO SEGUE O TRATAMENTO</strong> COMO DEVERIA?
            </ProblemTitle>

            <ProblemGrid>
              {sectionTwoProblems.map((item) => (
                <ProblemCard key={item.label}>
                  <ProblemIcon src={item.src} alt={item.label} />
                  <ProblemLabel>{item.label}</ProblemLabel>
                </ProblemCard>
              ))}
            </ProblemGrid>

            <PracticeTitle>
              VEJA COMO A TRATAZ RESOLVE ISSO NA PRÁTICA
            </PracticeTitle>

            <PracticeText>
              <strong>PRONTUÁRIO DIGITAL</strong> QUE <strong>ORGANIZA</strong>{" "}
              SEUS PACIENTES, <strong>AUTOMATIZA</strong> RELATÓRIOS E{" "}
              <strong>AUMENTA A FLUIDEZ</strong> DOS ATENDIMENTOS.
            </PracticeText>

            <SectionTwoCta type="button" onClick={onOpenPlans}>
              CLIQUE AQUI E ESCOLHA SEU MELHOR PLANO
            </SectionTwoCta>
          </SectionTwoInner>
        </SectionTwo>
  );
}
